import React, { useState } from "react";
import {
  Briefcase,
  Calendar,
  Star,
  Eye,
  TrendingUp,
  TrendingDown,
  MoreVertical,
  MapPin,
  Video,
  PlayCircle
} from "lucide-react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell
} from "recharts";
import "./TalentDashboard.css";
import axios from "axios";
import { useEffect } from "react";
import { fetchTalentDashboardApi } from "../../../services/api";
import ModernAuditionCard from "../../../components/ModernAuditionCard";
import { useNavigate } from "react-router-dom";



const TalentDashboard = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [dashboardData, setDashboardData] = useState(null);
const [loading, setLoading] = useState(true);
const navigate = useNavigate();
const mockKpis = [
  {
    title: "Total Applications",
    value: dashboardData?.kpis?.totalApplications || 0,
    icon: <Briefcase />,
    trend: "+12%",
    isPositive: true
  },

  {
    title: "Upcoming Auditions",
    value: dashboardData?.kpis?.upcomingAuditions || 0,
    icon: <Calendar />,
    trend: "+2",
    isPositive: true
  },

  {
    title: "Profile Views",
    value: dashboardData?.kpis?.profileViews || 0,
    icon: <Eye />,
    trend: "+24%",
    isPositive: true
  },

  {
    title: "Profile Score",
    value: dashboardData?.kpis?.profileScore || "0%",
    icon: <Star />,
    trend: "-2%",
    isPositive: false
  }
];
useEffect(() => {

  fetchDashboard();

}, []);

const fetchDashboard = async () => {

  try {

    const response =
    await fetchTalentDashboardApi();

    setDashboardData(response.data.data);

  } catch (error) {

    console.log(error);

  } finally {

    setLoading(false);
  }
};

  const getStatusBadge = (status) => {
    const s = status.toLowerCase();
    if (s === "applied") return <span className="td-badge badge-gray">Applied</span>;
    if (s === "reviewed") return <span className="td-badge badge-blue">Reviewed</span>;
    if (s === "scheduled") return <span className="td-badge badge-yellow">Scheduled</span>;
    if (s === "shortlisted") return <span className="td-badge badge-green">Shortlisted</span>;
    if (s === "rejected") return <span className="td-badge badge-red">Rejected</span>;
    return <span className="td-badge badge-gray">{status}</span>;
  };

  return (
    <div className="td-wrapper">
      <div className="td-container">
        
        {/* HEADER */}
        <div className="td-header">
          <div>
            <h1 className="td-title">My Dashboard</h1>
            <p className="td-subtitle">Welcome back! Track your auditions and find your next big role.</p>
          </div>
          <button className="td-btn-primary">
            <PlayCircle size={18} /> Upload Self-Tape
          </button>
        </div>

        {/* KPI CARDS (Borderless & Clean) */}
        <div className="td-kpi-grid">
          {mockKpis.map((kpi, index) => (
            <div className="td-kpi-card" key={index}>
              <div className="kpi-top">
                <div className="kpi-icon-box">{kpi.icon}</div>
                <div className={`kpi-trend ${kpi.isPositive ? 'positive' : 'negative'}`}>
                  {kpi.isPositive ? <TrendingUp size={14} /> : <TrendingDown size={14} />}
                  <span>{kpi.trend}</span>
                </div>
              </div>
              <h3 className="kpi-value">{kpi.value}</h3>
              <p className="kpi-label">{kpi.title}</p>
            </div>
          ))}
        </div>

        {/* MIDDLE SECTION: CHART & RECOMMENDED */}
        <div className="td-middle-grid">
          
          {/* GRAPH CARD */}
          <div className="td-card td-chart-card">
            {/* <div className="card-header">
              <h2>Audition Activity</h2>
              <select className="td-select">
                <option>Last 6 Months</option>
                <option>This Year</option>
              </select>
            </div> */}

<div className="cdd-card-header">
  <h2>Audition Overview</h2>

</div>
            <div className="chart-container">

<ResponsiveContainer width="100%" height="100%">

  <BarChart
    data={dashboardData?.chartData || []}
    margin={{ top: 20, right: 10, left: -5, bottom: 0 }}
    barCategoryGap={35}
  >

    <CartesianGrid
      strokeDasharray="3 3"
      vertical={false}
      stroke="rgba(255,255,255,0.06)"
    />

    <XAxis
      dataKey="name"
      stroke="#6b7280"
      fontSize={12}
      tickLine={false}
      axisLine={false}
    />

    <YAxis
      stroke="#6b7280"
      fontSize={12}
      tickLine={false}
      axisLine={false}
    />


    <Tooltip
      cursor={{
        fill: "rgba(255,255,255,0.08)"
      }}
      content={({ active, payload, label }) => {

        if (active && payload && payload.length) {

          return (

            <div
              style={{
                background: "#0b0b0b",
                border: "1px solid rgba(255,255,255,0.08)",
                borderRadius: "14px",
                padding: "14px 16px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.45)"
              }}
            >

              <p
                style={{
                  margin: 0,
                  color: "#ffffff",
                  fontSize: "15px",
                  fontWeight: 700,
                  marginBottom: "10px"
                }}
              >
                {label}
              </p>

              <p
                style={{
                  margin: 0,
                  color: "#d1d5db",
                  fontSize: "14px",
                  fontWeight: 500
                }}
              >
                Count :{" "}
                <span
                  style={{
                    color: "#ffffff",
                    fontWeight: 700
                  }}
                >
                  {payload[0].value}
                </span>
              </p>

            </div>
          );
        }

        return null;
      }}
    />

    <Bar
      dataKey="applications"
      radius={[8, 8, 0, 0]}
      barSize={46}
    >

      {(dashboardData?.chartData || []).map((entry, index) => {

        const colors = [
          "#ff0000",
          "#3b82f6",
          "#8b5cf6",
          "#10b981",
          "#ff4d4f",
          "#f59e0b"
        ];

        return (
          <Cell
            key={`cell-${index}`}
            fill={colors[index % colors.length]}
          />
        );
      })}

    </Bar>

  </BarChart>

</ResponsiveContainer>
            </div>
             <div className="td-chart-stats">

            <div className="td-chart-stat-item">
              <span className="td-chart-dot applications"></span>
              <p>Applications</p>
            </div>

            <div className="td-chart-stat-item">
              <span className="td-chart-dot shortlisted"></span>
              <p>Shortlisted</p>
            </div>

            <div className="td-chart-stat-item">
              <span className="td-chart-dot pending"></span>
              <p>Pending</p>
            </div>

            <div className="td-chart-stat-item">
              <span className="td-chart-dot rejected"></span>
              <p>Rejected</p>
            </div>

          </div>
            
          </div>
          

        <div className="td-recommended-wrapper">
          <div className="card-header td-rec-header">
            <h2>Recommended for You</h2>
            {dashboardData?.recommendations?.length > 2 && (
              <button
                className="td-view-all-btn"
                onClick={() => navigate("/roles")}
              >
                View All
              </button>
            )}
          </div>

          <div className="td-recommended-slider">
            {dashboardData?.recommendations?.map((rec, index) => (
              <div className="td-recommended-slide" key={index}>
                <ModernAuditionCard
                  audition={{
                    id: rec.id,
                    jogetRoleId: rec.id,
                    urlSlug: rec.urlSlug || rec.project,
                    projectName: rec.project,
                    roleTitle: rec.desc,
                    roleCategory: rec.category,
                    projectImageUrl: rec.img,
                    auditionType: rec?.types?.join(";") || "Online",
                      projectEndDate: rec.endDate,
    projectStartDate: rec.startDate,
                    roleCost: {
                      totalAmount: rec.price?.replace("₹", "")?.trim()
                    }
                  }}
                />
              </div>
            ))}
          </div>
          </div>
        </div>

        {/* BOTTOM SECTION: TABLE */}
        <div className="td-card td-table-card">
          <div className="card-header">
            <h2>Recent Applications</h2>
            <div className="table-filters">
              <button className={activeTab === "all" ? "active" : ""} onClick={() => setActiveTab("all")}>All</button>
              <button className={activeTab === "shortlisted" ? "active" : ""} onClick={() => setActiveTab("shortlisted")}>Shortlisted</button>
            </div>
          </div>

          <div className="table-responsive">
            <table className="td-table">
              <thead>
                <tr>
                  <th>Project Name</th>
                  <th>Role Applied</th>
                  <th>Type</th>
                  <th>Applied On</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {/* {mockTableData.map((row) => ( */}
                {dashboardData?.applications?.map((row) => (
                  <tr key={row.id}>
                    <td>
                      <div className="table-project-cell">
                        <div className="project-avatar">{row.project.charAt(0)}</div>
                        <span className="project-name">{row.project}</span>
                      </div>
                    </td>
                    <td className="table-text-muted">{row.role}</td>
                    <td>
                      <div className="table-type-cell">
                        {row.type.includes("Online") ? <Video size={16}/> : <MapPin size={16}/>}
                        <span>{row.type}</span>
                      </div>
                    </td>
                    <td className="table-text-muted">{row.date}</td>
                    <td>{getStatusBadge(row.status)}</td>
                    <td>
                      <button className="table-action-btn"><MoreVertical size={18} /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default TalentDashboard;